import React, { useEffect, useRef, useState } from "react";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import { useHistory, useParams } from "react-router-dom";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
const Categories = (params) => {
  const history = useHistory();
  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div className="row mx-0">
                  <div className="container px-0">
                    <div className="shadowclass">
                      <div class="col-12">
                        <h4 class="event-alert"> Classes </h4>
                        <p>
                          Add and manage Menu Item Sub-Classes that can be used
                          for ongoing financial and operational analytics &amp;
                          reporting.
                        </p>
                      </div>
                      <div className="table-responsive min-wd-1200">
                        <table
                          class="checklist-table inventory_table remove-space categories_table"
                          width="100%"
                          cellspacing="0"
                          cellpadding="0"
                        >
                          <thead>
                            <tr>
                              <th> Class </th>
                              <th> Sub-Class </th>
                              <th> Status </th>
                              <th> # of Active Applicable Menu Item </th>
                              <th width={"18%"}> Last Updated </th>
                              <th className="text-center"> Actions </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="">
                              <td>
                                <button
                                  class="dropdown-green collapsed"
                                  type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne"
                                >
                                  {" "}
                                </button>
                                Alcoholic Beverage
                              </td>
                              <td width={"12%"}> </td>
                              <td width={"10%"}>
                                <span class="green_tag"> Active </span>
                              </td>
                              <td width={"18%"}> 259 </td>
                              <td width={"25%"}> </td>
                              <td> </td>
                            </tr>

                            <tr id="flush-collapseOne" class="accordion-collapse collapse" 
                            >
                              <td colspan="6" class="p-0">
                                <table class="table m-0">
                                  <tbody>
                                    <tr class="sub_category_row sub_class_row">
                                      <td class="sub_td_first" width="23%">
                                        {" "}
                                        &nbsp;&nbsp; Alcoholic Beverage
                                      </td>

                                      <td width={"12%"}> Beer </td>
                                      <td width={"10%"}>
                                        {" "}
                                        <span class="green_tag"> Active </span>
                                      </td>
                                      <td width={"18%"}> 38 </td>
                                      <td width={"25%"}> 10/01/2022 </td>
                                      <td className="">
                                        <div className="d-flex justify-content-center">
                                          <a
                                            class="circle_icon editSubClass"
                                            href="#_"
                                            val="969"
                                          >
                                            {" "}
                                            <i class="iconSprites edit-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Edit{" "}
                                              </div>
                                            </i>{" "}
                                          </a>

                                          <a
                                            href="#_"
                                            class="delete_sub_class circle_icon"
                                          >
                                            <i class="iconSprites delete-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Delete{" "}
                                              </div>
                                            </i>
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                    
                                    <tr class="sub_category_row sub_class_row">
                                      <td class="sub_td_first" width="23%">
                                        {" "}
                                        &nbsp;&nbsp; Alcoholic Beverage
                                      </td>

                                      <td width={"12%"}> Beer </td>
                                      <td width={"10%"}>
                                        {" "}
                                        <span class="green_tag"> Active </span>
                                      </td>
                                      <td width={"18%"}> 38 </td>
                                      <td width={"25%"}> 10/01/2022 </td>
                                      <td className="">
                                        <div className="d-flex justify-content-center">
                                          <a
                                            class="circle_icon editSubClass"
                                            href="#_"
                                            val="969"
                                          >
                                            {" "}
                                            <i class="iconSprites edit-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Edit{" "}
                                              </div>
                                            </i>{" "}
                                          </a>

                                          <a
                                            href="#_"
                                            class="delete_sub_class circle_icon"
                                          >
                                            <i class="iconSprites delete-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Delete{" "}
                                              </div>
                                            </i>
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>

                            
                            <tr class="">
                              <td>
                                <button
                                  class="dropdown-green collapsed"
                                  type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo"
                                >
                                  {" "}
                                </button>
                                Alcoholic Beverage
                              </td>
                              <td width={"12%"}> </td>
                              <td width={"10%"}>
                                <span class="green_tag"> Active </span>
                              </td>
                              <td width={"18%"}> 259 </td>
                              <td width={"25%"}> </td>
                              <td> </td>
                            </tr>
                            

                            <tr id="flush-collapseTwo" class="accordion-collapse collapse" 
                            >
                              <td colspan="6" class="p-0">
                                <table class="table m-0">
                                  <tbody>
                                    <tr class="sub_category_row sub_class_row">
                                      <td class="sub_td_first" width="23%">
                                        {" "}
                                        &nbsp;&nbsp; Alcoholic Beverage
                                      </td>

                                      <td width={"12%"}> Beer </td>
                                      <td width={"10%"}>
                                        {" "}
                                        <span class="green_tag"> Active </span>
                                      </td>
                                      <td width={"18%"}> 38 </td>
                                      <td width={"25%"}> 10/01/2022 </td>
                                      <td className="">
                                        <div className="d-flex justify-content-center">
                                          <a
                                            class="circle_icon editSubClass"
                                            href="#_"
                                            val="969"
                                          >
                                            {" "}
                                            <i class="iconSprites edit-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Edit{" "}
                                              </div>
                                            </i>{" "}
                                          </a>

                                          <a
                                            href="#_"
                                            class="delete_sub_class circle_icon"
                                          >
                                            <i class="iconSprites delete-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Delete{" "}
                                              </div>
                                            </i>
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                    
                                    <tr class="sub_category_row sub_class_row">
                                      <td class="sub_td_first" width="23%">
                                        {" "}
                                        &nbsp;&nbsp; Alcoholic Beverage
                                      </td>

                                      <td width={"12%"}> Beer </td>
                                      <td width={"10%"}>
                                        {" "}
                                        <span class="green_tag"> Active </span>
                                      </td>
                                      <td width={"18%"}> 38 </td>
                                      <td width={"25%"}> 10/01/2022 </td>
                                      <td className="">
                                        <div className="d-flex justify-content-center">
                                          <a
                                            class="circle_icon editSubClass"
                                            href="#_"
                                            val="969"
                                          >
                                            {" "}
                                            <i class="iconSprites edit-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Edit{" "}
                                              </div>
                                            </i>{" "}
                                          </a>

                                          <a
                                            href="#_"
                                            class="delete_sub_class circle_icon"
                                          >
                                            <i class="iconSprites delete-icon">
                                              <div class="tooltip-sm">
                                                {" "}
                                                Delete{" "}
                                              </div>
                                            </i>
                                          </a>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>

                          </tbody>
                        </table>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Categories;
